<template>
    <v-card elevation="2" outlined>
        <v-card-title>
            جزئیات درخواست
            <v-spacer/>
            <v-icon>mdi-information</v-icon>
        </v-card-title>

        <v-divider/>

        <v-list>
            <v-list-item>
                <v-list-item-icon>
                    <v-icon>mdi-code-less-than-or-equal</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title v-text="request.user_info.nid"/>
                    <v-list-item-subtitle>کد ملی</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-list-item>
                <v-list-item-icon>
                    <v-icon>mdi-book-variant</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title v-text="request.user_info.mcode"/>
                    <v-list-item-subtitle>شماره شناسنامه</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-list-item>
                <v-list-item-icon>
                    <v-icon>mdi-human-male-boy</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title v-text="request.user_info.father_name"/>
                    <v-list-item-subtitle>نام پدر</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>


            <v-list-item>
                <v-list-item-icon>
                    <v-icon>mdi-note-text-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title v-text="request.user_info.postalCode"/>
                    <v-list-item-subtitle>کد پستی</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-list-item>
                <v-list-item-icon>
                    <v-icon>mdi-map-marker-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title v-text="request.user_info.address"/>
                    <v-list-item-subtitle>آدرس محل سکونت</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>



            <v-list-item>
                <v-list-item-icon>
                    <v-icon>mdi-shield-check</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title v-text="request.user_info.created_at"/>
                    <v-list-item-subtitle>تاریخ درخواست</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-list-item>
                <v-list-item-icon>
                    <v-icon>mdi-file</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title v-text="'تصویر شناسنامه'"/>
                    <v-list-item-subtitle>
                        <td v-text="'نمایش'" class="clickable" @click="getUserFile(request.birthCertificatePicture)">
                            <v-chip v-text="'نمایش'"/>
                        </td>
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-list-item>
                <v-list-item-icon>
                    <v-icon>mdi-file</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title v-text="'تصویر کارت ملی'"/>
                    <v-list-item-subtitle>
                        <td v-text="'نمایش'" class="clickable" @click="getUserFile(request.user_info.nidimage)">
                            <v-chip v-text="'نمایش'"/>
                        </td>
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

        </v-list>
    </v-card>
</template>

<script>
export default {
    name: "requestDetails",
    data: () => ({
        residenceProvince: null,
        residenceCity: null,
        employmentProvince: null,
        employmentCity: null,

    }),
    props: ['request'],

    methods: {
        getUserFile(url) {
            let a = document.createElement('a');
            a.target = '_blank';
            a.href = this.uploadUrl + url;
            a.click();
        },

    }

}
</script>

<style scoped>

</style>
